const widgetVisualization = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M5.2 6v8H2V6zM14 2v12h-3.2V2zM9.6 4v10H6.4V4z"/></svg>',
};

export { widgetVisualization as default };
